export default __webpack_public_path__ + "static/media/st_intro.0dd37364.png";